module.exports = __webpack_public_path__ + "public/images/sold_out.2e9dcbaa3f3b3f2146a3db40b56545bd.png";